module.exports = __webpack_public_path__ + "img/Hatchbacks.3326c325.svg";